module.exports = __webpack_public_path__ + "img/gfx-screensharing.a44308df.svg";